// Module
var code = "<div ng-class=\"{\n    'c-addAssociation-disabledCell': row.entity.isDisabled\n}\">\n    <div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\" ui-grid-cell></div>\n</div>\n";
// Exports
module.exports = code;